import { Module } from 'vuex';
import api from '@/core/api/modules/contracts';
import * as types from '../mutation-types';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface State {}

const initialState: State = {};

const contractsModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {},
  actions: {
    async getSignedContracts(
      _,
      { status, q, page, product, startDate, endDate }
    ) {
      return await api.getSignedContracts(
        page,
        status,
        q,
        product,
        startDate,
        endDate
      );
    },
    async deleteSignedContract(_, signedContractId) {
      return await api.deleteSignedContract(signedContractId);
    },
    async updateSignedContract(_, contract) {
      return await api.updateSignedContract(contract);
    },
    async uploadSignedContract(_, contract) {
      return await api.uploadSignedContract(contract);
    },
    async resendSignedContract(_, contractId) {
      return await api.resendSignedContract(contractId);
    },
    async getContracts(_, { q, page }) {
      return await api.getContracts(page, q);
    },
    async getContract(_, contractId) {
      return await api.getContract(contractId);
    },
    async getAllContracts(_, { q }) {
      return await api.getAllContracts(q);
    },
    async createContract(_, contract) {
      return await api.createContract(contract);
    },
    async updateContract(_, contract) {
      return await api.updateContract(contract);
    },
    async sendContractToSign(_, payload) {
      return await api.sendContractToSign(payload.contract, payload);
    },
  },
  mutations: {},
};

export default contractsModule;
